import { Typography } from '@mui/material';
import AppShellLoader from 'components/AppShellLoader';
import { Permission } from 'interfaces/permissionOption';
import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { isAuthenticationError } from 'utils/httpError';
import { usePermissions } from 'utils/usePermissions';
import AccessionDashboard from './AccessionDashboard/AccessionDashboard';
import PrivateRoute from './Auth/PrivateRoute';
import { LoadingStage } from './Loader';
import StudiesDashboard from './StudiesDashboard';

interface MainPageProps {
  isAuthenticated: boolean;
}

const MainPageRoute: FunctionComponent<React.PropsWithChildren<MainPageProps>> = ({ isAuthenticated }) => {
  const { error, hasPermission, isError, isLoading } = usePermissions();
  const location = useLocation();
  const isUnauthorizedError = isError && isAuthenticationError(error);
  const shouldOpenCreateStudyModal = Boolean(
    (location.state as { openCreateStudyModal?: boolean } | null)?.openCreateStudyModal
  );

  if (isUnauthorizedError) {
    console.error('Error loading permissions', { isError, error });
    return (
      <Typography variant="h6" color="error">
        Error loading permissions. Please try again later.
      </Typography>
    );
  }

  if (isLoading && isAuthenticated) {
    return <AppShellLoader stage={LoadingStage.CheckingAccess} />;
  } else if (isError) {
    console.error('Error loading permissions', { isError, error });
    return (
      <Typography variant="h6" color="error">
        Error loading permissions. Please try again later.
      </Typography>
    );
  }

  if (hasPermission(Permission.ViewAccessionDashboard) && !shouldOpenCreateStudyModal) {
    return (
      <PrivateRoute
        component={AccessionDashboard}
        isAuthenticated={isAuthenticated}
        permissionsRequired={[Permission.ViewAccessionDashboard]}
      />
    );
  } else {
    return <PrivateRoute component={StudiesDashboard} isAuthenticated={isAuthenticated} />;
  }
};

export default MainPageRoute;
